export const fromHexToRgb = (hex: string): Array<number> => {
  const h = hex.replace('#', '');

  const r = parseInt(`${h[0]}${h[1]}`, 16);
  const g = parseInt(`${h[2]}${h[3]}`, 16);
  const b = parseInt(`${h[4]}${h[5]}`, 16);

  return [r, g, b];
};
